export default "<div id=\"contenedor\" [innerHTML]=\"articulo\"></div>"